//TODO: Get this from workflow config
export const contributions = [
  'Conceptualization',
  'Data curation',
  'Formal analysis',
  'Funding acquisition',
  'Investigation',
  'Methodology',
  'Project administration',
  'Resources',
  'Software',
  'Supervision',
  'Validation',
  'Visualization',
  'Writing – original draft',
  'Writing – review & editing'
];

//TODO: Get this from workflow config
export const degrees = ['Lead', 'Equal', 'Supporting'];
